import React from 'react';

export default function Products() {
  return (
    <div className="page">
      <h1>Products Management</h1>
      <p>Products list coming soon...</p>
    </div>
  );
}
